/**
 * Button props builders for ConfirmModal
 * Extracted to reduce component size
 */

import { EButtonVariant } from "../../Button";

export interface BuildButtonPropsParams {
	variant: "danger" | "warning" | "info";
	requireConfirmation?: {
		enabled: boolean;
		expectedValue: string;
	};
	confirmationValue: string;
	loading: boolean;
}

/**
 * Gets default button variant based on modal variant
 */
export function getDefaultButtonVariant(variant: "danger" | "warning" | "info"): EButtonVariant {
	switch (variant) {
		case "danger":
			return EButtonVariant.ERROR;
		case "warning":
			return EButtonVariant.WARNING;
		case "info":
		default:
			return EButtonVariant.PRIMARY;
	}
}

/**
 * Checks if confirm button should be disabled
 */
export function isConfirmButtonDisabled(params: BuildButtonPropsParams): boolean {
	const { requireConfirmation, confirmationValue } = params;
	if (requireConfirmation?.enabled) {
		const ev = requireConfirmation.expectedValue;
		if (typeof ev !== "string" || ev.trim().length === 0) {
			return true;
		}
		return confirmationValue !== ev;
	}
	return false;
}
